import { Link, NavLink } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";

// Paths that must never be language-prefixed.
const NO_PREFIX = ["/loginmanage", "/concepts"];

const shouldPrefix = (to) =>
  typeof to === "string" &&
  to.startsWith("/") &&
  !NO_PREFIX.some((p) => to === p || to.startsWith(`${p}/`));

// Drop-in replacement for react-router <Link> that keeps the active language
// prefix on internal navigation (e.g. /fr/product/x while browsing in French).
export const LangLink = ({ to, ...props }) => {
  const { lp } = useI18n();
  const dest = shouldPrefix(to) ? lp(to) : to;
  return <Link to={dest} {...props} />;
};

// Language-aware <NavLink> (keeps the active-route styling via `isActive`).
export const LangNavLink = ({ to, ...props }) => {
  const { lp } = useI18n();
  const dest = shouldPrefix(to) ? lp(to) : to;
  return <NavLink to={dest} {...props} />;
};
